<div class="property-value-filter">
<c-input type="text" model-property="$ctrl.filter.PropertyName"></c-input>
<c-autoform-select id="$ctrl.filter.id" options="$ctrl.filter.options" selected-option="$ctrl.filter.selected"></c-autoform-select>
<c-input type="text" model-property="$ctrl.filter.PropertyValue"></c-input>
<button class="property-value-filter-delete" ng-click="$ctrl.deleteFilter()">{{$ctrl.filter.deleteLabel}}</button>
</div>
